// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__ghv9F","alertIcon":"ConfirmModal_alertIcon__1HaX0"};